import 'quasar/dist/quasar.css'
import '@quasar/extras/material-icons/material-icons.css'
import { Dialog, Notify } from 'quasar'

export default {
  config: {
    dark: true,
    brand: {
      primary: '#ffab3e',
      secondary: '#d58925',
      accent: '#1E1E1E',
      dark: '#272727',
      positive: '#21BA45',
      negative: '#C10015',
      info: '#004DBC',
      warning: '#F2C037'
    },
    notify: {
      position: 'bottom-right',
      timeout: 1000,
      progress: true,
      classes: 'text-weight-bold'
    }
  },
  plugins: {
    Dialog,
    Notify
  }
}